import { Controller } from "@hotwired/stimulus"

// Manages dynamic form fields for payment method types
// Shows/hides relevant fields based on selected method type
export default class extends Controller {
  static targets = [
    "methodType",
    "accountFields",
    "bankFields",
    "instructionsFields",
    "qrPhotoFields",
    "accountName",
    "accountNumber",
    "bankName"
  ]

  connect() {
    this.updateFieldVisibility()
  }

  methodTypeChanged() {
    this.updateFieldVisibility()
  }

  updateFieldVisibility() {
    const methodType = this.methodTypeTarget.value

    // Reset all fields
    this.hideAllFields()
    this.clearRequiredAttributes()

    switch (methodType) {
      case "gcash":
      case "maya":
        this.showAccountFields()
        this.showQrPhotoFields()
        break
      case "bank_transfer":
        this.showAccountFields()
        this.showBankFields()
        this.showQrPhotoFields()
        break
      case "cash":
      case "check":
      case "other":
        this.showInstructionsFields()
        break
    }
  }

  hideAllFields() {
    if (this.hasAccountFieldsTarget) {
      this.accountFieldsTarget.classList.add("hidden")
    }
    if (this.hasBankFieldsTarget) {
      this.bankFieldsTarget.classList.add("hidden")
    }
    if (this.hasInstructionsFieldsTarget) {
      this.instructionsFieldsTarget.classList.add("hidden")
    }
    if (this.hasQrPhotoFieldsTarget) {
      this.qrPhotoFieldsTarget.classList.add("hidden")
    }
  }

  showAccountFields() {
    if (this.hasAccountFieldsTarget) {
      this.accountFieldsTarget.classList.remove("hidden")
      // Set required attributes
      if (this.hasAccountNameTarget) {
        this.accountNameTarget.required = true
      }
      if (this.hasAccountNumberTarget) {
        this.accountNumberTarget.required = true
      }
    }
  }

  showBankFields() {
    if (this.hasBankFieldsTarget) {
      this.bankFieldsTarget.classList.remove("hidden")
      // Set required attribute for bank name
      if (this.hasBankNameTarget) {
        this.bankNameTarget.required = true
      }
    }
  }

  showInstructionsFields() {
    if (this.hasInstructionsFieldsTarget) {
      this.instructionsFieldsTarget.classList.remove("hidden")
    }
  }

  showQrPhotoFields() {
    if (this.hasQrPhotoFieldsTarget) {
      this.qrPhotoFieldsTarget.classList.remove("hidden")
    }
  }

  clearRequiredAttributes() {
    if (this.hasAccountNameTarget) {
      this.accountNameTarget.required = false
    }
    if (this.hasAccountNumberTarget) {
      this.accountNumberTarget.required = false
    }
    if (this.hasBankNameTarget) {
      this.bankNameTarget.required = false
    }
  }
}
